import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "motion/react";
import { transitionSoft, viewportOnce } from "../animations";

function Advanteg() {
  const { t } = useTranslation();
  const items = t("advantages.items", { returnObjects: true });
  const list = Array.isArray(items) ? items : [];

  return (
    <section className="m-auto mt-[50px] px-4 md:mt-[60px] lg:mt-[80px] lg:max-w-[1024px] xl:mt-[144px] xl:max-w-[1280px] ">
      <div className="flex flex-col justify-around md:flex-row">
        <div className="md:w-[597px]">
          <motion.h4
            className="mb-[56px] text-[20px] font-medium uppercase text-[#da0011] md:text-[26px] lg:text-[30px] xl:text-[36px]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportOnce}
            transition={transitionSoft}
          >
            {t("advantages.heading")}
          </motion.h4>
          <ul className="space-y-[10px] md:space-y-[20px] lg:space-y-[34px] xl:space-y-[44px]">
            {list.map((text, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={viewportOnce}
                transition={{ ...transitionSoft, delay: 0.06 + i * 0.07 }}
                whileHover={{ x: 4 }}
                className="flex cursor-pointer place-items-center border-b-[2px] pb-[6px] text-[18px] font-medium hover:text-[#da0011] md:border-hidden md:pb-[0]"
              >
                <img alt="" className="absolute" src="./img/litleRomb.svg" />
                <div className="relative flex items-center">
                  <h4
                    className={`z-0 mr-[20px] text-[36px] ${i === 3 ? "pl-[12px]" : "pl-[14px]"}`}
                  >
                    {i + 1}
                  </h4>
                  <p>{text}</p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
        <motion.div
          className="flex justify-center md:block"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ ...transitionSoft, delay: 0.12 }}
        >
          <motion.img
            className="phoneStyleAdvan ml-[70px] mt-[25px] md:ml-[0] md:mt-[0]"
            src="./img/phone.svg"
            alt=""
            animate={{ y: [0, -8, 0] }}
            transition={{
              duration: 4.5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </motion.div>
      </div>
    </section>
  );
}

export default Advanteg;
